import { Col, Row } from "react-bootstrap";
import Stat from "../Common/Stat";
import StatBar from "../Common/StatBar";
import "../QuestionReport.css";
import IsSmallScreen from "../Common/IsSmallScreen";

import { htmlDecode } from "../../../../utils/parse";

const HotQuestion = ({ q, studentId,index }) => {
  const corrAns = q.questionId.correctAnswers.descriptive[0]?.answer;
  let markedAns = "";

  // Overall Attempts
  let st = q.statistics.filter((stats) => (stats?.answer?.descriptive?.answer || "").toLowerCase() === (corrAns || "").toLowerCase());
  
  // Selected User Attempt
  const user = q.statistics.filter(
    (stats) => stats.userId === studentId
  );

  let userExplanation = null;
  let userFile = null;
  let status = "";
  if (user && user.length) {
    userExplanation = user[0]?.answer?.descriptive?.answer;
    userFile = user[0]?.answer?.descriptive?.file;
    status = user[0]?.status;
  }

  return (
    <Row className="analytics_question_layer">
      <Col className="analytics_question_content">
        <Row className="analytics_question_heading">
          <p>Question {index}</p>
          {q.questionId?.difficulty ? <p className="analytics_question_heading_card">
            {q.questionId.difficulty}
          </p>:null}
          {q.questionId.cognitive ? <p className="analytics_question_heading_card">
            {q.questionId.cognitive}
          </p>:null}
        </Row>
        <Row
          className="analytics_question_statement"
          dangerouslySetInnerHTML={{
            __html: htmlDecode(q.questionId.question),
          }}
        />
        <br/>
                {/* ✅ Explanation Section */}
                {(userExplanation || userFile) && (
                  <Row className="analytics_question_statement">
                    <label>Student Answer:</label>
        
        <div style={{ color: status === "correct" ? "#7EB6A2" : "#FF675E" }}>
                    {userExplanation && (
                      <p
                        style={{fontWeight:"bold"}}
                        dangerouslySetInnerHTML={{
                          __html: htmlDecode(userExplanation),
                        }}
                      />
                    )}
        
                    {userFile && (
                      <a style={{ color: status === "correct" ? "#7EB6A2" : "#FF675E" }} href={userFile.link} target="_blank" rel="noreferrer">
                        📄 View File: {userFile.name}
                      </a>
                    )}
                    </div>
                  </Row>
                )}

                {/* ✅ Correct Explanation */}
                        {q.questionId.correctAnswers?.descriptive[0]
                           && (
                          <Row className="analytics_question_statement">
                            <label>Correct Answer:</label>
                            <p>
                              <b>
                              {q.questionId.correctAnswers.descriptive[0].answer}
                              </b>
                            </p>
                          </Row>
                        )}
     
        
      </Col>
      <Col className="analytics_question_stats">
        <Stat>
          <StatBar
            style={{
              width: (st.length / q.statistics.length) * 180,
              backgroundColor: "#7EB6A2",
            }}
          />{" "}
          {(st.length / q.statistics.length) * 100}%
        </Stat>
      </Col>
    </Row>
  );
};

export default HotQuestion;